<template>
    <b-container fluid class="bg-clight web-register">
        <div>
            
        <div class="log-box">
            <img src="../../assets/logo.png" class="logo-img" alt="LOGO" srcset="">
            <span @click="goBack()" class="back">返回网站</span>
        </div>
        <b-container class="form-content d-flex flex-column">
            <div class="form-content-titlle">
                <span class="register-text">会员注册</span>
                <span class="register-en">Member Registration</span>
            </div>
            <div class="form-body">
                <div class="form-item">
                    <div class="form-label">请选择注册类型</div>
                    <div class="form-radio">
                        <el-radio-group v-model="formText.member_type">
                            <el-radio label="1" size="large">个人会员</el-radio>
                            <el-radio label="2" size="large">单位会员</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <el-form ref="personForm" key="personForm" label-position="left" :model="formText" :rules="personRules" label-width="136px" class="group-box person" v-if="formText.member_type=='1'">
                    <el-form-item label="您所在的专业分会" class="form-input" prop="member_info.branch_no">
                        <el-select class="w-100" multiple v-model="formText.member_info.branch_no" placeholder="请选择您所在的专业分会">
                            <el-option
                                v-for="item in deptList"
                                :key="item.dept_no"
                                :label="item.dept_name"
                                :value="item.dept_no">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设置密码" class="form-input" prop="member_info.pwd">  
                        <el-input v-model="formText.member_info.pwd" placeholder="请输入密码"></el-input>                     
                    </el-form-item>
                    <el-form-item label="确认密码" class="form-input" prop="member_info.confirm_pwd">  
                        <el-input v-model="formText.member_info.confirm_pwd" placeholder="请输入确认密码"></el-input>                     
                    </el-form-item>
                    <div class="group-title">个人信息</div>
                    <el-form-item label="手机号" class="form-input" prop="person_info.phone_no"> 
                        <el-input v-model="formText.person_info.phone_no" placeholder="请输入手机号"></el-input>                     
                    </el-form-item>
                    <el-form-item label="验证码" class="form-input" prop="code"> 
                        <el-input v-model="formText.code" placeholder="请输入验证码">
                            <el-button slot="append" :disabled="codeState || !isPhoneValid" :class="{ 'code-btn-active': isPhoneValid && !codeState }" @click="getCode">{{codeState ? `剩余${codeTime}s` : `获取验证码`}}</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名" class="form-input" prop="person_info.real_name">  
                        <el-input v-model="formText.person_info.real_name" placeholder="请输入真实姓名"></el-input>                     
                    </el-form-item>
                    <el-form-item label="性别" class="form-input" prop="person_info.sex">  
                         <el-radio-group v-model="formText.person_info.sex">
                            <el-radio label="1" size="large">男</el-radio>
                            <el-radio label="2" size="large">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="身份证号码" class="form-input" prop="person_info.card_no">                        
                        <el-input v-model="formText.person_info.card_no" placeholder="请输入身份证号码"></el-input>                   
                    </el-form-item>
                    <el-form-item label="免冠证件照" class="form-input" prop="person_info.id_photo">
                        <upload-image
                            v-model="formText.person_info.id_photo"
                            :placeholder-img="require('@/assets/upload-img.png')"
                            :width="99"
                            :height="116"
                            table-name="bxws_member_info"
                            columns="id_photo"
                            @change="onIdPhotoChange">
                        </upload-image>
                        <!-- <div class="upload-tip-text">请上传免冠证件照，支持jpg/jpeg/png格式，大小不超过2MB</div> -->
                    </el-form-item>
                    <div class="group-title">工作信息</div>
                    <el-form-item label="工作单位" class="form-input" prop="work_unit">  
                        <el-input v-model="formText.work_unit" placeholder="请输入工作单位"></el-input>                    
                    </el-form-item>
                    <el-form-item label="科室/部门" class="form-input" prop="dept">  
                        <el-input v-model="formText.dept" placeholder="请输入科室/部门"></el-input>                      
                    </el-form-item>
                    <el-form-item label="职称" class="form-input" prop="prof_title">  
                        <el-input v-model="formText.prof_title" placeholder="请输入职称"></el-input>
                    </el-form-item>
                    <el-form-item label="职务" class="form-input" prop="position">  
                        <el-input v-model="formText.position" placeholder="请输入职务"></el-input>
                    </el-form-item>   
                    
                    <div class="register-btn" @click="handleRegister('person')">注册</div>                 
                </el-form>
                <el-form ref="companyForm" key="companyForm" label-position="left" :model="formText" :rules="companyRules" label-width="136px" class="group-box person" v-if="formText.member_type=='2'">
                    <div class="group-title">基本信息</div>
                    <el-form-item label="单位名称" class="form-input" prop="org_info.org_name">  
                        <el-input v-model="formText.org_info.org_name" placeholder="请输入单位名称"></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用码" class="form-input" prop="org_info.org_society_id">  
                        <el-input v-model="formText.org_info.org_society_id" placeholder="请输入统一社会信用码"></el-input>                     
                    </el-form-item>
                    <el-form-item label="单位地址" class="form-input" prop="org_info.org_addr">  
                        <el-input v-model="formText.org_info.org_addr" placeholder="请输入单位地址"></el-input>                     
                    </el-form-item>
                    <el-form-item label="联系电话" class="form-input" prop="org_info.org_contact_tel"> 
                        <el-input v-model="formText.org_info.org_contact_tel" placeholder="请输入手机号"></el-input>                     
                    </el-form-item>
                    <el-form-item label="验证码" class="form-input" prop="org_info.org_code"> 
                        <el-input v-model="formText.org_info.org_code" placeholder="请输入验证码">
                            <el-button slot="append" :disabled="companyCodeState || !isCompanyPhoneValid" :class="{ 'code-btn-active': isCompanyPhoneValid && !companyCodeState }" @click="getCompanyCode">{{companyCodeState ? `剩余${companyCodeTime}s` : `获取验证码`}}</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="企业营业执照" class="form-input" prop="org_info.biz_license">
                        <upload-image
                            v-model="formText.org_info.biz_license"
                            :placeholder-img="require('@/assets/upload-img2.png')"
                            :width="134"
                            :height="116"
                            table-name="bxws_member_info"
                            columns="biz_license"
                            @change="onBizLicenseChange">
                        </upload-image>
                        <!-- <div class="upload-tip-text">请上传企业营业执照，支持jpg/jpeg/png格式，大小不超过2MB</div> -->
                    </el-form-item>
                    <div class="group-title">法人信息</div>
                    <el-form-item label="真实姓名" class="form-input" prop="org_legal_person.fr_name">  
                        <el-input v-model="formText.org_legal_person.fr_name" placeholder="请输入真实姓名"></el-input>                     
                    </el-form-item>
                    <el-form-item label="性别" class="form-input" prop="org_legal_person.fr_sex">  
                        <el-radio-group v-model="formText.org_legal_person.fr_sex">
                            <el-radio label="1" size="large">男</el-radio>
                            <el-radio label="2" size="large">女</el-radio>
                        </el-radio-group>                   
                    </el-form-item>

                    <el-form-item label="身份证号码" class="form-input" prop="org_legal_person.fr_idcard_no">                        
                        <el-input v-model="formText.org_legal_person.fr_idcard_no" placeholder="请输入身份证号码"></el-input>                
                    </el-form-item>                
                    <div class="register-btn" @click="handleRegister('company')">注册</div>                   
                </el-form>
            </div>

        </b-container>
        </div>
        
    </b-container>
</template>
  
<script>  
import store from '@/store'
import bg from '@/assets/bg.jpg'
  
import register from '@/components/register.vue'
import copyright from '@/components/copyright.vue'
import UploadImage from '@/components/upload-image.vue'

import formMixin from '@/utils/form.js'
import { setRequest,sendCode,getListData } from '@/api/api.js'
var codeTime = null
var companyCodeTimer = null
  export default {
    components: {
        register,copyright,UploadImage
    },
    mixins:[formMixin],
    props: {
      msg: String
    },
    computed:{
        authState(){
            let type = '未注册'
            if(this.info.memberInfo && this.info.memberInfo.auth_state){
                type = this.info.memberInfo.auth_state
            }

            return type
        },
        info(){
            let state = {
                isLogin:store.getters.getLoginState,
                info:store.getters.getLoginInfo,
                memberInfo:store.getters.getMemberInfo
             }

             return state
        },
        register(){
            let config  = this.webConfig.hander.register || {
                text:'注册',
                show:true,
                ayoutTitle:"个人会员注册",
                layoutMsg:"",
                loginPath:"/register",
                toHome:true
            }
            return config
        },
        logos(){
            let info = store.getters.getWebConfig['_logos']
            let logos = []
            if(Array.isArray(info) &&  info.length > 0){
                logos = info.map(item => item)
                console.log('logo register',logos)
            }
            return logos
        },
        formFields(){
            let fields = []
            if(Array.isArray(this.fields)){
                fields = this.fields.map(item => {
                    if(item.column == 'member_type'){
                        item.value = '个人'
                    }
                    if(this.authState == '不通过' && this.info.memberInfo && this.info.memberInfo.hasOwnProperty(item.column)){
                        item.value = this.info.memberInfo[item.column]
                        item['updateed'] = 0
                        if(['phone_no','member_type'].indexOf(item.column) == -1){
                            item['updateed'] = 1
                        }
                    }
                    
                    return    item
                })
            }
            

            return fields
        },

        isPhoneValid(){
            return /^1[3-9]\d{9}$/.test(this.formText.person_info.phone_no)
        },
        isCompanyPhoneValid(){
            return /^1[3-9]\d{9}$/.test(this.formText.org_info.org_contact_tel)
        },
        personRules(){
            return {
                'member_info.branch_no': [
                    { required: true, message: '请选择您所在的专业分会', trigger: 'change' },
                    { type: 'array', min: 1, message: '请至少选择一个专业分会', trigger: 'change' }
                ],
                'member_info.pwd': [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                'member_info.confirm_pwd': [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: this.validateConfirmPwd, trigger: 'blur' }
                ],
                'person_info.phone_no': [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                'code': [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                'person_info.real_name': [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                ],
                'person_info.sex': [
                    { required: true, message: '请输入性别', trigger: 'blur' }
                ],
                'person_info.card_no': [
                    { required: true, message: '请输入身份证号码', trigger: 'blur' },
                    { pattern: /^\d{17}[\dXx]$/, message: '请输入正确的身份证号码', trigger: 'blur' }
                ],
                'person_info.id_photo': [
                    { required: true, message: '请上传免冠证件照', trigger: 'change' }
                ],
                'work_unit': [
                    { required: true, message: '请输入工作单位', trigger: 'blur' }
                ],
                'dept': [
                    { required: true, message: '请输入科室/部门', trigger: 'blur' }
                ],
                'prof_title': [
                    { required: true, message: '请输入职称', trigger: 'blur' }
                ],
                'position': [
                    { required: true, message: '请输入职务', trigger: 'blur' }
                ]
            }
        },

        companyRules(){
            return {
                'org_info.org_name': [
                    { required: true, message: '请输入单位名称', trigger: 'blur' }
                ],
                'org_info.org_society_id': [
                    { required: true, message: '请输入统一社会信用码', trigger: 'blur' }
                ],
                'org_info.org_addr': [
                    { required: true, message: '请输入单位地址', trigger: 'blur' }
                ],
                'org_info.org_contact_tel': [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                'org_info.org_code': [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                'org_info.biz_license': [
                    { required: true, message: '请上传企业营业执照', trigger: 'change' }
                ],
                'org_legal_person.fr_name': [
                    { required: true, message: '请输入法人真实姓名', trigger: 'blur' }
                ],
                'org_legal_person.fr_sex': [
                    { required: true, message: '请选择法人性别', trigger: 'blur' }
                ],
                'org_legal_person.fr_idcard_no': [
                    { required: true, message: '请输入法人身份证号码', trigger: 'blur' },
                    { pattern: /^\d{17}[\dXx]$/, message: '请输入正确的身份证号码', trigger: 'blur' }
                ]
            }
        }
    },
    data(){
        return {
            formText:{
                member_type:'1',
                code: '',
                member_info:{
                    branch_no:[],
                    pwd:'',
                    confirm_pwd:'',  
                },
                person_info:{
                    phone_no:'',
                    real_name:'',
                    sex:'',
                    card_no:'',
                    id_photo:''
                },
                org_info:{
                    org_name:'',
                    org_society_id:'',
                    org_addr:'',
                    org_contact_tel:'',
                    org_code:'',
                    biz_license:''  
                },
                org_legal_person:{
                    fr_name:'',
                    fr_sex:'',
                    fr_idcard_no:''
                }
            },
            codeState: false,
            codeTime: 0,
            companyCodeState: false,
            companyCodeTime: 0,

            deptList: [],
            form:{
            "password": "",
            "passwordb": "",
            "checked": [],
            "phone":'',
            "code":""
            },
            bgurl:bg,
            fields:[
                {
                    "label": "姓名",
                    "column": "name",
                    "type": "text",
                    "value": null,
                    "placeholder": "请输入名称...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "名称不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "会员类型",
                    "column": "member_type",
                    "type": "radio",
                    "value": '个人',
                    "placeholder": "请输入会员类型...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "会员类型不能为空"
                        }
                    ],
                    
                    "state": null,
                    "msg": "",
                    "show": false
                },
                {
                    "label": "性别",
                    "column": "sex",
                    "type": "radio",
                    "value": null,
                    "placeholder": "请输入性别...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "性别不能为空"
                        }
                    ],
                    "options":[{"text":"男","value":"男"},{"text":"女","value":"女"}],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                // {
                //     "label": "网站编码",
                //     "column": "website_no",
                //     "type": "text",
                //     "value": store.getters.getWebConfig.website_no,
                //     "placeholder": "请输入网站编码...",
                //     "rules": [
                //         {
                //             "type": "required",
                //             "trigger": "change",
                //             "msg": "网站编码不能为空"
                //         }
                //     ],
                //     "state": null,
                //     "msg": "",
                //     "show": false
                // },
                {
                    "label": "手机",
                    "column": "phone_no",
                    "type": "text",
                    "value": null,
                    "placeholder": "请输入联系电话...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "请填写有效的手机号"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "验证码",
                    "column": "code",
                    "type": "code",
                    "value": null,
                    "placeholder": "验证码...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "请填写有效的验证码"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                }
            ]
        }
    },
    created(){
        // console.log(this.webConfig)
        this.getDept();
    },
    methods:{
        // 获取组织部门
        getDept(){
            let serviceName = 'srvws_dept_anon_select'
            let req = {
                "serviceName": serviceName,
                "colNames": [
                    "*"
                ],
                "condition": [
                    {
                        "colName": "parent_no",
                        "ruleType": "isnull"
                    },
                    {"colName": "website_no", "value": store.getters.getWebConfig.website_no},
                ],
                "relation_condition": {},
                "page": {
                    "pageNo": 1,
                    "rownumber": 9999
                },
                "order": [],
                "draft": null,
                "vpage_no": "845bb241e7753da0fca38c91cd517b01",
                "use_type": "treelist"
            }
            getListData (req,'ws',serviceName).then(res=>{
                console.log("获取组织部门：",res)
                if(res.state == "SUCCESS"){
                    this.deptList=res.data;
                }
            })
        },
        onIdPhotoChange() {
            if (this.$refs.personForm) {
                this.$refs.personForm.validateField('person_info.id_photo')
            }
        },
        onBizLicenseChange() {
            if (this.$refs.companyForm) {
                this.$refs.companyForm.validateField('org_info.biz_license')
            }
        },
         validator(tag) {
            // 自定义验证逻辑，例如限制标签长度或去重
            if (this.selectedTags.includes(tag)) {
                return false // 不允许重复添加
            }
            return tag.length > 0
        },
        onSubmit(evt) {
            let self = this
            let values = {}
            let valids = []
            let isValid = true
            for(let field of this.formFields){
                if(field.rules && field.rules.length > 0){
                    for(let rule of field.rules){
                        if(rule.type == 'required'){
                            valids.push(field.column)
                        }
                    }
                }
                values[field.column] = field.value
                // field.state(field.value)
            }
            for(let key of valids){
                if(!values[key]){
                    isValid = false
                }
            }
            this.validFeedback()
            
            if(isValid){
                let serviceName = 'srvws_member_info_reg_add'
                let app = 'ws'
                let req =  [
                    {
                        "serviceName": serviceName,
                        "data": [
                            values
                        ]
                    }
                ]
                setRequest(req,'operate',serviceName,app).then(res=>{
                        console.log(res.data)
                        if(res.state == 'SUCCESS'){
                            this.submit = true
                            let self = this
                            // console.log(this)
                                this.$bvModal.msgBoxConfirm('注册成功:初始密码是注册手机号后六位.', {
                                    title: '请确认',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'primary',
                                    okTitle: '前往登录',
                                    cancelTitle: '取消',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true
                                })
                            .then(value => {
                                console.log(value)
                                if(value == true){
                                    self.$router.replace({path:'/login' })
                                }
                            })
                            .catch(err => {
                                // An error occurred
                            })
                        }else{
                            this.$bvModal.msgBoxOk(res.resultMessage, {
                                title: '请确认',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'primary',
                                okTitle: '确认',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            })
                            .then(value => {
                            // this.boxOne = value
                            })
                            .catch(err => {
                            // An error occurred
                            })
                        }
                    })
                    

            }
            console.log(values)
        },
        onReset(evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.email = ''
            this.form.name = ''
            this.form.food = null
            this.form.checked = []
            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        },
        goBack(){
            this.$router.push('/')
        },
        getCode(){
            console.log('获取验证码')
            let phone = this.formText.person_info.phone_no

            if(!phone || !/^1[3-9]\d{9}$/.test(phone)){
                this.$message.error('请输入正确的手机号')
                return
            }

            let req = [{
                "serviceName": "srvmobile_note_send",
                "data": [{
                    "mobile": phone
                }]
            }]
            
            sendCode(req).then(res => {
                if(res.state=="SUCCESS"){
                    console.log('获取成功')
                    let countdown = res.response[0].response.exp_time
                    if(countdown){
                        this.codeState = true
                        this.countdown(countdown)
                    }
                    
                }else{
                    this.$bvModal.msgBoxOk(res.resultMessage, {
                        title: '请确认',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: '确认',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                    })
                    .catch(err => {
                    })
                }
            })
        },
        countdown(countdown){
            localStorage.setItem('codeTime',countdown)
            this.codeTime = countdown
            codeTime = setInterval(()=>{
                let time = localStorage.getItem('codeTime')
                this.codeTime = time
                if(time && time >= 1){
                    time = (time - 1)
                    localStorage.setItem('codeTime',time)
                }else{
                    time = 0
                    localStorage.setItem('codeTime',0)
                    clearInterval(codeTime);
                    this.codeState = false
                }
            }, 1000);
            console.log('倒计时',countdown)
        },
        getCompanyCode(){
            console.log('获取企业验证码')
            let phone = this.formText.org_info.org_contact_tel

            if(!phone || !/^1[3-9]\d{9}$/.test(phone)){
                this.$message.error('请输入正确的手机号')
                return
            }

            let req = [{
                "serviceName": "srvmobile_note_send",
                "data": [{
                    "mobile": phone
                }]
            }]
            
            sendCode(req).then(res => {
                if(res.state=="SUCCESS"){
                    console.log('获取成功')
                    let countdown = res.response[0].response.exp_time
                    if(countdown){
                        this.companyCodeState = true
                        this.companyCountdown(countdown)
                    }
                    
                }else{
                    this.$bvModal.msgBoxOk(res.resultMessage, {
                        title: '请确认',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: '确认',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                    })
                    .catch(err => {
                    })
                }
            })
        },
        companyCountdown(countdown){
            localStorage.setItem('companyCodeTime',countdown)
            this.companyCodeTime = countdown
            companyCodeTimer = setInterval(()=>{
                let time = localStorage.getItem('companyCodeTime')
                this.companyCodeTime = time
                if(time && time >= 1){
                    time = (time - 1)
                    localStorage.setItem('companyCodeTime',time)
                }else{
                    time = 0
                    localStorage.setItem('companyCodeTime',0)
                    clearInterval(companyCodeTimer);
                    this.companyCodeState = false
                }
            }, 1000);
            console.log('企业验证码倒计时',countdown)
        },

        validateConfirmPwd(rule, value, callback) {
            if (value !== this.formText.member_info.pwd) {
                callback(new Error('两次输入的密码不一致'))
            } else {
                callback()
            }
        },

        resetPersonForm() {
            this.formText.member_info = {
                branch_no: [],
                pwd: '',
                confirm_pwd: ''
            }
            this.formText.person_info = {
                phone_no: '',
                real_name: '',
                sex: '',
                card_no: '',
                id_photo: ''
            }
            this.formText.work_unit = ''
            this.formText.dept = ''
            this.formText.prof_title = ''
            this.formText.position = ''
            this.formText.code = ''
            if (this.$refs.personForm) {
                this.$refs.personForm.resetFields()
            }
        },

        resetCompanyForm() {
            this.formText.org_info = {
                org_name: '',
                org_society_id: '',
                org_addr: '',
                org_contact_tel: '',
                org_code: '',
                biz_license: ''
            }
            this.formText.org_legal_person = {
                fr_name: '',
                fr_sex: '',
                fr_idcard_no: ''
            }
            if (this.$refs.companyForm) {
                this.$refs.companyForm.resetFields()
            }
        },

        handleRegister(formType) {
            const formRef = formType === 'person' ? this.$refs.personForm : this.$refs.companyForm
            if (!formRef) return

            if (formType === 'person') {
                this.resetCompanyForm()
            } else {
                this.resetPersonForm()
            }
            
            formRef.validate((valid) => {
                if (valid) {
                    let values = {}
                    if (formType === 'person') {
                        const { confirm_pwd, ...memberInfo } = this.formText.member_info
                        let branch_no=this.formText.member_info.branch_no.join(",");
                        values = {
                            ...memberInfo,
                            ...this.formText.person_info,
                            branch_no: this.branch_no,
                            name: this.formText.person_info.real_name,
                            member_type: '个人',
                            work_unit: this.formText.work_unit,
                            dept: this.formText.dept,
                            prof_title: this.formText.prof_title,
                            position: this.formText.position,
                            code: this.formText.code
                        }
                    } else {
                        const { org_code, ...orgInfo } = this.formText.org_info
                        let branch_no=this.formText.member_info.branch_no.join(",");
                        values = {
                            ...orgInfo,
                            ...this.formText.org_legal_person,
                            branch_no: this.branch_no,
                            name: this.formText.org_legal_person.fr_name,
                            phone_no: this.formText.org_info.org_contact_tel,
                            sex: this.formText.org_legal_person.fr_sex,
                            member_type: '企业',
                            code: org_code
                        }
                    }

                    let serviceName = 'srvws_member_info_reg_add'
                    let app = 'ws'
                    let req = [
                        {
                            "serviceName": serviceName,
                            "data": [
                                values
                            ]
                        }
                    ]
                    setRequest(req, 'operate', serviceName, app).then(res => {
                        console.log(res.data)
                        if (res.state == 'SUCCESS') {
                            this.submit = true
                            let self = this
                            this.$bvModal.msgBoxConfirm('注册成功:初始密码是注册手机号后六位.', {
                                title: '请确认',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'primary',
                                okTitle: '前往登录',
                                cancelTitle: '取消',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            })
                                .then(value => {
                                    console.log(value)
                                    if (value == true) {
                                        self.$router.replace({ path: '/login' })
                                    }
                                })
                                .catch(err => {
                                })
                        } else {
                            this.$bvModal.msgBoxOk(res.resultMessage, {
                                title: '请确认',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'primary',
                                okTitle: '确认',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            })
                                .then(value => {
                                })
                                .catch(err => {
                                })
                        }
                    })
                } else {
                    console.log('表单验证失败')
                }
            })
        }
    }

  }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  $primary: #45c28d !default;  
    ::v-deep .el-form-item__content{
        text-align: left !important;
    }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .register-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 182px;
    height: 36px;
    margin:0 auto;
    border-radius: 4px;
    background-color: rgba(1,103,56,1);
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
  }
  ::v-deep .code-btn-active{
    background-color: rgba(64,196,128,1) !important;
    color: #fff !important;
    border-color: rgba(64,196,128,1) !important;
  }
  .company{
    .register-btn{
        margin-top: 179px;

    }
  }
  .upload-tip-text{
    font-size: 12px;
    color: #909399;
    margin-top: 6px;
    white-space: nowrap;
  }
  .group-title{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    width: 128px;

    color: rgba(16,16,16,1);
    font-size: 16px;
    &::before{
        content: " ";
        display: inline-block;
        width: 4px;
        height: 15px;
        margin-right: 13px;
        background-color: rgba(1,103,56,1);
    }
  }
  .bg-clight{
    background: linear-gradient(11.25deg, rgba(179,216,255,0.48) 1.23%,rgba(14,205,195,0.27) 58.7%,rgba(4,111,53,0.45) 111.96%);
    background-image: url('../../assets/register-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    }
  .web-register{
    width: 100vw;
    height: 100vh;
    padding: 0;
    padding-bottom: 67px;
    overflow-y: auto;
    box-sizing: border-box;
    .web-register-hander{
        .copyright{
            width: 100vw;
            justify-content: center;
        }
        .logo{
             height: 40px;
        }
    } 
    .register-layout{
        // height: calc(100vh - 90px);
        width:100%;
    }
  }
  
.log-box{
    width: 100%;
    display: flex;
    align-items: center;
    padding:10px 30px;
    box-sizing: border-box;
    .logo-img{
        width: 180px;
        height: 42px;
    }
    .back{
        display: inline-block;
        width: 109px;
        height: 30px;
        margin-left: 43px;
        line-height: 28px;
        border-radius: 4px;
        color: rgba(1,103,56,1);
        font-size: 14px;
        text-align: center;
        font-family: -regular;
        border: 1px solid rgba(1,103,56,1);
        box-sizing: border-box;
        cursor: pointer;

    }
}
.form-content{
    width: 100vw;
    height: calc(100% - 62px);
    .form-content-titlle{
        width: 100%;
        height: 58px;
        padding: 17px 40px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        background: url('../../assets/form-title-bg.png') no-repeat left top;
        background-size: 100% 100%;

        .register-text{
            color: rgb(1,103,56);
            font-size: 20px;
        }
        .register-en{
            display: flex;
            align-items: center;
            padding-left: 10px;
            color: rgba(1,103,56,1);
            font-size: 14px;
            &:before{
                content: '';
                display: inline-block;
                width: 1px;
                height: 24px;
                margin-right: 10px;
                background-color: rgba(1,103,56,1);

            }
        }
    }
    .form-body{
        width: 100%;
        padding: 20px 40px;
        background-color: #fff;
        box-sizing: border-box;
        .form-item{
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            &:last-child{
                margin-bottom: 0px;
            }
            .form-label{
                display: flex;
                width: 128px;
                margin-right: 26px;
                color: rgb(16,16,16);
                font-size: 16px;
                font-family: SourceHanSansSC-regular;
            }
            .form-radio{
                display: flex;
            }
            .form-input{
                display: flex;
                width: 681px;
                input,select{
                    width: 100%;
                    height: 38px;
                    line-height: 20px;
                    border-radius: 4px;
                    background-color: rgba(255,255,255,1);
                    color: rgba(136,136,136,1);
                    font-size: 14px;
                    text-align: left;
                    font-family: PingFangSC-regular;
                    border: 1px solid rgba(229,229,234,1);
                    box-sizing: border-box;
                }
            }
        }

    }

}
  </style>
  